<ng-container *transloco="let t; prefix: 'dsaManagement.infrastructure.bdrsForm'">
  <h2 mat-dialog-title class="form-dialog__title">
    {{ isEdit ? t('editTitle') : t('addTitle') }}
  </h2>

  <mat-dialog-content class="form-dialog__content">
    <p class="form-dialog__hint">{{ t('lifecycleHint') }}</p>

    <htx-form-section [formGroup]="form">
      <htx-text-field-with-error
        [ctrl]="form.controls.bpn"
        [label]="t('bpn')"
        [errorMessages]="errorMessagesService.messages()"
      ></htx-text-field-with-error>

      <htx-text-field-with-error
        [ctrl]="form.controls.did"
        [label]="t('did')"
        [errorMessages]="errorMessagesService.messages()"
      ></htx-text-field-with-error>
    </htx-form-section>
  </mat-dialog-content>

  <mat-dialog-actions class="form-dialog__actions" align="end">
    <htx-button variant="tertiary" size="small" (buttonClick)="cancel()">
      {{ t('cancel') }}
    </htx-button>
    <htx-button variant="primary" size="small" [disabled]="form.invalid" (buttonClick)="save()">
      {{ t('submit') }}
    </htx-button>
  </mat-dialog-actions>
</ng-container>
